import React, { FC } from "react";
import classes from "./UI_ITOModuleDocumentsList.module.css";

import { DownloadOutlined } from "@ant-design/icons";

import { UI_ModuleDocuments } from "../indexUI";

import { TagLeadSign } from "../../components/Application/ApplicationDetails/ApplicationDetailsDoсList/TagSign/TagLeadSign";
import { TagSign } from "../../components/Application/ApplicationDetails/ApplicationDetailsDoсList/TagSign/TagSign";
import { applicationBankDocumentsApi } from "../../services/documents/documents.api";
import { useAppDispatch } from "../../store/reduxHooks";
import { OPEN_SIGN_INFO_MODAL } from "../../store/slices/applicationBankSlice/applicationBankSlice";
import { getLeadSign } from "../../utils/utilities/documents/getLeadSign";
import { getClientSign } from "../../utils/utilities/documents/getClientSign";
import { DocumentWithMetaData } from "../../types/documents.type";
import { GetSignInfoQueryParams } from "../../store/api/applicationBankApi/signing.api";

interface UI_ITOModuleDocumentsListProps {
  docs: DocumentWithMetaData[];
  applicationBankId: number;
}

const { downloadDocument, downloadDocumentSignFile, showAnketa } =
  applicationBankDocumentsApi;

const getDocumentTitleDown = (documentDto: DocumentWithMetaData) => {
  if (documentDto.type === "ANKETA") {
    return "Анкета.pdf";
  }
  if (documentDto.document?.name) {
    return documentDto.document.name;
  }
  return "Документ не загружен";
};

export const UI_ITOModuleDocumentsList: FC<UI_ITOModuleDocumentsListProps> = ({
  docs,
  applicationBankId,
}) => {
  const onClickDownloadFile = async (doc: DocumentWithMetaData) => {
    if (doc.type === "ANKETA" && !doc.document) {
      showAnketa({ applicationBankId });
      return;
    }

    if (doc.document && doc.document.application_banks_id) {
      downloadDocument({
        applicationBankId: doc.document.application_banks_id,
        fileId: doc.document?.id,
        fileName: doc.document.name,
      });
      return;
    }
  };

  const dispatch = useAppDispatch();

  const openSignInfoModal = (params: GetSignInfoQueryParams) => {
    dispatch(OPEN_SIGN_INFO_MODAL(params));
  };
  return (
    <>
      {docs?.map((documentDto: DocumentWithMetaData) => {
        const leadSignFile = getLeadSign(documentDto.document);
        const clientSignFile = getClientSign(documentDto.document);
        return (
          <div
            key={documentDto.name + documentDto.id}
            className={
              documentDto.document || documentDto.type === "ANKETA"
                ? classes.documentCard
                : classes.documentEmpty
            }
          >
            <UI_ModuleDocuments
              title={documentDto.name}
              titleDown={getDocumentTitleDown(documentDto)}
              icon={
                <>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                      gap: "10px",
                    }}
                  >
                    <TagLeadSign
                      tag={leadSignFile ? "sign_true" : "sign_false"}
                      onClickDownload={() => {
                        if (
                          documentDto.document &&
                          applicationBankId &&
                          leadSignFile
                        ) {
                          downloadDocumentSignFile({
                            applicationBankId: Number(applicationBankId),
                            fileId: documentDto.document.id,
                            signId: leadSignFile.id,
                            fileName: leadSignFile.name,
                          });
                        }
                      }}
                      onClickSignInfo={() => {
                        if (
                          documentDto.document &&
                          applicationBankId &&
                          leadSignFile
                        ) {
                          openSignInfoModal({
                            applicationBankId: Number(applicationBankId),
                            fileId: documentDto.document.id,
                            signId: leadSignFile.id,
                          });
                        }
                      }}
                    />
                    {/* Подписи клиента на Решении быть не может, поэтому не показываем при типе документа Решение */}
                    {documentDto.type !== "KKB_DECISION" && (
                      <TagSign
                        tag={clientSignFile ? "sign_true" : "sign_false"}
                        onClickDownload={() => {
                          if (
                            documentDto.document &&
                            applicationBankId &&
                            clientSignFile
                          ) {
                            downloadDocumentSignFile({
                              applicationBankId: Number(applicationBankId),
                              fileId: documentDto.document.id,
                              signId: clientSignFile.id,
                              fileName: clientSignFile.name,
                            });
                          }
                        }}
                        onClickSignInfo={() => {
                          if (documentDto.document && applicationBankId) {
                            clientSignFile &&
                              openSignInfoModal({
                                applicationBankId: Number(applicationBankId),
                                fileId: documentDto.document.id,
                                signId: clientSignFile.id,
                              });
                          }
                        }}
                      />
                    )}
                  </div>
                  <DownloadOutlined
                    style={{ color: "black" }}
                    onClick={() => onClickDownloadFile(documentDto)}
                  />
                </>
              }
            />
          </div>
        );
      })}
    </>
  );
};
